module.exports = __webpack_public_path__ + "img/frozen_cauliflower_florets.c07a8f30.jpg";